import { useSession } from '@/context/session/useSession';
import { supabase } from '@fd/supabase/index';
import { SbOrder, SbPayment, SbSubscription } from '@fd/supabase/types';
import useSWR from 'swr';

export type Payment = SbPayment & {
  subscription?: SbSubscription;
  customer_order?: SbOrder;
};

export default function usePayments(page: number = 1, perPage: number = 10) {
  const { session } = useSession();
  const response = useSWR(
    session ? ['payments', page, perPage] : null,
    async () => {
      const { data, count } = await supabase
        .from('payment')
        .select('*, subscription(*), customer_order!payment_order_id_fkey(*)', {
          count: 'exact',
        })
        .order('created_at', { ascending: false })
        .range((page - 1) * perPage, page * perPage)
        .throwOnError();
      return { data, count };
    }
  );
  return {
    ...response,
    data: response.data ? (response.data.data as Payment[]) : [],
    pages: Math.ceil((response.data?.count ?? 0) / perPage),
  };
}
